import axios from 'axios';
import moment from 'moment';

class CsrfTokenService {
  loading = false;
  INVALID_CSRF_ERROR_MESSAGE = 'invalid csrf token';

  constructor() {
    this.initializeToken();
  }

  isCsrfTokenValid() {
    const csrfToken = localStorage.getItem('csrfToken');
    const csrfTokenExpiry = localStorage.getItem('csrfTokenExpiry');

    if (!csrfToken || !csrfTokenExpiry) return false;

    return moment().isBefore(moment(csrfTokenExpiry));
  }

  async initializeToken() {
    if (this.isCsrfTokenValid()) {
      axios.defaults.headers.common['x-csrf-token'] =
        localStorage.getItem('csrfToken')!;

      return;
    }

    if (!this.loading) {
      this.loading = true;

      try {
        const { data } = await axios.get<{ _csrf: string; expiry?: string }>(
          '/csrfToken',
          {
            headers: {
              'Cache-Control': 'no-cache',
              'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT', // https://github.com/BrokerBay/app/pull/4517#discussion_r482083423
            },
          },
        );

        if (!data._csrf) {
          localStorage.removeItem('csrfToken');
          localStorage.removeItem('csrfTokenExpiry');
        } else {
          localStorage.setItem('csrfToken', data._csrf);
          if (data.expiry && moment(data.expiry).isValid()) {
            localStorage.setItem(
              'csrfTokenExpiry',
              new Date(data.expiry).toISOString(),
            );
          } else {
            // setting expiry time for token as csrf cookie expires in 24 hours
            localStorage.setItem(
              'csrfTokenExpiry',
              moment().add(24, 'hour').toISOString(),
            );
          }

          axios.defaults.headers.common['x-csrf-token'] = data._csrf;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }

  async getToken(): Promise<string> {
    if (!this.isCsrfTokenValid()) {
      await this.initializeToken();
    }

    return localStorage.getItem('csrfToken') || '';
  }

  clearCsrfCache() {
    localStorage.removeItem('csrfToken');
    localStorage.removeItem('csrfTokenExpiry');
  }
}

export default new CsrfTokenService();
